/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
 
  this.atc_button = document.querySelector('[data-fixed-atc]');
  if (atc_button) {
    this.screenHeight = document.documentElement.clientHeight;
    window.addEventListener('scroll', this.updateFixed.bind(this));
    this.updateFixed();
    
    try {
      customElements.define('fixed-atc', FixedATC);
    }
    catch(e) {
      console.log("fixed-atc already defined", e)
    }
  }

  // Mobile Quickview Add to Cart Button Management
  let mobileQuickviewButton = null;

  function createMobileQuickviewButton() {
    if (window.innerWidth <= 767 && !mobileQuickviewButton) {
      // Create mobile button once and keep it in DOM
      mobileQuickviewButton = document.createElement('button');
      mobileQuickviewButton.id = 'quickview-mobile-atc';
      mobileQuickviewButton.innerHTML = 'Loading...';
      document.body.appendChild(mobileQuickviewButton);
      console.log('Mobile quickview button created!');
    }
  }

  function updateMobileQuickviewButton() {
    if (!mobileQuickviewButton || window.innerWidth > 767) return;
    
    const quickviewModal = document.querySelector('.quickview__modal.is-open');
    if (quickviewModal) {
      // Get the original form
      const originalForm = quickviewModal.querySelector('form[data-product-form]');
      if (!originalForm) return;
      
      // Get product data
      const addToCartText = originalForm.querySelector('[data-add-to-cart-text]')?.textContent || 'Add to Cart';
      const buttonPrice = originalForm.querySelector('[data-button-price]')?.textContent || '';
      
      // Update button content
      mobileQuickviewButton.innerHTML = `${addToCartText} ${buttonPrice ? '• ' + buttonPrice : ''}`;
      
      // Update click handler (remove old ones first)
      mobileQuickviewButton.replaceWith(mobileQuickviewButton.cloneNode(true));
      mobileQuickviewButton = document.getElementById('quickview-mobile-atc');
      
      mobileQuickviewButton.addEventListener('click', function() {
        const currentForm = document.querySelector('.quickview__modal.is-open form[data-product-form]');
        const originalButton = currentForm?.querySelector('button[name="add"]');
        if (originalButton) {
          originalButton.click();
        } else if (currentForm) {
          currentForm.submit();
        }
      });
      
      // Add body class to show button
      document.body.classList.add('quickview-open');
      console.log('Mobile quickview button updated and shown!');
    }
  }

  function hideMobileQuickviewButton() {
    document.body.classList.remove('quickview-open');
    console.log('Mobile quickview button hidden!');
  }

  // Create button on page load
  createMobileQuickviewButton();

  // Listen for quickview open
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-quickview]')) {
      setTimeout(updateMobileQuickviewButton, 500);
    }
  });

  // Listen for modal close - multiple ways to detect close
  document.addEventListener('click', function(e) {
    // Close button clicked
    if (e.target.matches('[data-micromodal-close]') || e.target.closest('[data-micromodal-close]')) {
      hideMobileQuickviewButton();
    }
    // Clicked outside modal (underlay)
    if (e.target.matches('.drawer__underlay') || e.target.closest('.drawer__underlay')) {
      hideMobileQuickviewButton();
    }
  });

  // Also listen for ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.querySelector('.quickview__modal.is-open')) {
      hideMobileQuickviewButton();
    }
  });

  // Use MutationObserver to detect when quickview modal closes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('quickview__modal')) {
          if (!target.classList.contains('is-open')) {
            hideMobileQuickviewButton();
          }
        }
      }
    });
  });

  // Start observing for changes
  const quickviewModal = document.querySelector('.quickview__modal');
  if (quickviewModal) {
    observer.observe(quickviewModal, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Listen for variant changes
  document.addEventListener('theme:variant:change', function(event) {
    if (event.target.closest('.quickview__modal')) {
      setTimeout(updateMobileQuickviewButton, 100);
    }
  });

  // Handle window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 767) {
      createMobileQuickviewButton();
    }
  });

  // Mobile sticky CTA for CPB "Débuter la personnalisation":
  // pushes Smile + Chat launchers up so they don't visually collide with the always-visible CTA.
  // The CTA itself stays sticky via CSS (position: fixed) — no scroll-hide logic.
  (function setupPersonalizeStickyCTA() {
    if (window.innerWidth > 767) return;

    function apply() {
      const cta = document.querySelector('.personalize-it--js');
      if (!cta) return false;

      const smile = document.querySelector('.smile-launcher-frame-container');
      const chat = document.querySelector('#chat-button');
      if (smile) smile.classList.add('cta-personalize');
      if (chat) chat.classList.add('cta-personalize');

      // Done once everything is present
      return Boolean(smile && chat);
    }

    if (!apply()) {
      const observer = new MutationObserver(() => {
        if (apply()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Safety cutoff so we don't observe forever if a widget never loads
      setTimeout(() => observer.disconnect(), 30000);
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

function disconnectedCallback() {
  window.removeEventListener('scroll', this.updateFixed)
};

function updateFixed() {
  const screenBottom = window.pageYOffset + this.screenHeight;
  let footerOffsetTop = document.querySelector('.shopify-section-group-group-footer').getBoundingClientRect().top + window.scrollY;
  atc_button.classList.toggle('open', screenBottom <= footerOffsetTop);

  this.smile_button = document.querySelector('.smile-launcher-frame-container');
  this.chat_button = document.querySelector('#chat-button');

  if (smile_button) {
    smile_button.classList.toggle('open', screenBottom <= footerOffsetTop);
  }

  if (chat_button) {
    chat_button.classList.toggle('open', screenBottom <= footerOffsetTop);
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    if (smile_button) {
      smile_button.classList.toggle('variant-sold-out', !variant.available);
    }
    if (chat_button) {
      chat_button.classList.toggle('variant-sold-out', !variant.available);
    }
  });
};

/*
 * FOMO badges (docs/fomo-badges-handoff.md)
 * 1. PDP low stock and per-variant purchases lines (snippets/fomo-urgency.liquid):
 *    each JSON lists only the variants that get a line, with the rendered text;
 *    swap them when the variant changes.
 * 2. "Stock limité" in the Rebuy Smart Cart: Rebuy renders from /cart.js, which has
 *    no stock, so the low variants come from sections/fomo-cart-stock.liquid.
 *    Rebuy.SmartCart.items() is in display order; the product-<handle> class on each
 *    row guards the index match, and a mismatch adds nothing rather than a wrong line.
 *    Rows live in ul[data-smartcart-items] (no class on the list). Rebuy re-renders
 *    them with Vue, which can drop the label: an observer on .rebuy-cart__flyout puts it back.
 */
(function() {
  function readJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  // On mobile the lines sit in the sticky add to cart bar and make it taller; the
  // chat and Smile launchers are lifted by that height (theme.css, .fixed-atc).
  function syncBarOffset() {
    var block = document.querySelector('.fixed-atc [data-fomo-urgency]');
    var height = block ? Math.round(block.getBoundingClientRect().height) : 0;
    document.body.classList.toggle('fomo-bar-lines', height > 0);
    document.body.style.setProperty('--fomo-bar-extra', height + 'px');
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail && event.detail.variant;
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-fomo-urgency]').forEach(function(block) {
      // Low stock and, when the app counted purchases per variant, the purchases line.
      [['[data-fomo-stock]', '[data-fomo-stock-json]'], ['[data-fomo-signal]', '[data-fomo-signal-json]']].forEach(function(pair) {
        var line = block.querySelector(pair[0]);
        if (!line) return;
        var texts = readJson(block.querySelector(pair[1])) || {};
        var text = variant ? texts[String(variant.id)] : '';
        line.textContent = text || '';
        line.hidden = !text;
      });
    });
    syncBarOffset();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBarOffset);
  } else {
    syncBarOffset();
  }
  window.addEventListener('load', syncBarOffset);
  document.addEventListener('theme:resize', syncBarOffset);

  var cartInfo = null;
  var observed = null;
  var applyQueued = false;

  function cartRows() {
    return document.querySelectorAll('[data-smartcart-items] > .rebuy-cart__flyout-item');
  }

  function applyCartStock() {
    applyQueued = false;
    if (!cartInfo || !window.Rebuy || !Rebuy.SmartCart || typeof Rebuy.SmartCart.items !== 'function') return;
    var items = Rebuy.SmartCart.items() || [];
    cartRows().forEach(function(row, index) {
      var item = items[index];
      var wanted = !!(item && row.classList.contains('product-' + item.handle) && cartInfo.variants.indexOf(item.variant_id) !== -1);
      var line = row.querySelector('.fomo-cart-stock');
      if (!wanted) {
        if (line) line.remove();
        return;
      }
      if (line) return;
      // Rebuy's info block is a wrapping flex row: title and variant take 100%,
      // quantity and price 50% each. A loose element lands between them and pushes
      // both out, so the label sits beside the variant ("4 oz · Stock limité"), or,
      // when the line has no variant (bundles), on its own line in the variant slot.
      var variantTitle = row.querySelector('.rebuy-cart__flyout-item-variant-title');
      if (variantTitle) {
        line = document.createElement('span');
        line.className = 'fomo-cart-stock';
        line.textContent = cartInfo.label;
        variantTitle.appendChild(line);
        return;
      }
      var title = row.querySelector('.rebuy-cart__flyout-item-product-title');
      if (!title) return;
      line = document.createElement('div');
      line.className = 'rebuy-cart__flyout-item-variant-title fomo-cart-stock';
      line.textContent = cartInfo.label;
      title.insertAdjacentElement('afterend', line);
    });
  }

  function queueApply() {
    if (applyQueued) return;
    applyQueued = true;
    window.requestAnimationFrame(applyCartStock);
  }

  function observeCart() {
    var flyout = document.querySelector('.rebuy-cart__flyout');
    if (!flyout || flyout === observed) return;
    observed = flyout;
    new MutationObserver(queueApply).observe(flyout, { childList: true, subtree: true });
  }

  function refreshCartStock() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?sections=fomo-cart-stock', { credentials: 'same-origin' })
      .then(function(response) {
        return response.ok ? response.json() : null;
      })
      .then(function(data) {
        if (!data || !data['fomo-cart-stock']) return;
        var doc = new DOMParser().parseFromString(data['fomo-cart-stock'], 'text/html');
        var info = readJson(doc.querySelector('[data-fomo-cart-stock]'));
        if (!info || !Array.isArray(info.variants)) return;
        cartInfo = info;
        observeCart();
        queueApply();
      })
      .catch(function() {});
  }

  document.addEventListener('rebuy:smartcart.ready', refreshCartStock);
  document.addEventListener('rebuy:cart.change', function() {
    window.setTimeout(refreshCartStock, 0);
  });
  // rebuy.js can be ready before this deferred file runs
  if (document.querySelector('.rebuy-cart__flyout')) refreshCartStock();
})();

/*
 * "Lire plus" on rich text blocks (the collection SEO footer)
 * sections/section-richtext.liquid wraps a text block in [data-seo-collapse] only when its
 * plain text is longer than the block's collapse_after. Here the body is clipped just under
 * the line holding the data-preview-chars-th character, measured on the laid-out text: titles,
 * lists and links are never cut mid-tag, and the clip follows the wrapping at any width.
 * The text stays in the HTML (crawlable). Without JS it shows in full and the button stays
 * hidden (theme.css, .seo-collapse).
 */
(function() {
  var MIN_HIDDEN = 48; // px; collapsing that hides less than this is not worth a button

  // Bottom of the line holding the limit-th character, in px from the top of body, or null
  function previewBottom(body, limit) {
    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
    var count = 0;
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue.trim()) continue;
      var length = node.nodeValue.length;
      if (count + length >= limit) {
        var end = Math.max(1, Math.min(limit - count, length));
        var range = document.createRange();
        range.setStart(node, end - 1);
        range.setEnd(node, end);
        var rects = range.getClientRects();
        if (!rects.length) return null;
        return rects[rects.length - 1].bottom - body.getBoundingClientRect().top;
      }
      count += length;
    }
    return null;
  }

  function setup(root) {
    var body = root.querySelector('[data-seo-collapse-body]');
    var toggle = root.querySelector('[data-seo-collapse-toggle]');
    if (!body || !toggle) return null;

    var limit = parseInt(root.getAttribute('data-preview-chars'), 10) || 400;
    var expanded = false;
    var collapsible = false;
    var timer = null;

    // Collapsed height in px, or null when the text is too short to be worth collapsing
    function measure() {
      var bottom = previewBottom(body, limit);
      var height = bottom === null ? null : Math.ceil(bottom) + 6;
      collapsible = height !== null && body.scrollHeight - height >= MIN_HIDDEN;
      return collapsible ? height : null;
    }

    function setState(open) {
      expanded = open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = toggle.getAttribute(open ? 'data-label-less' : 'data-label-more');
    }

    function open() {
      window.clearTimeout(timer);
      setState(true);
      root.classList.remove('is-collapsed');
      body.style.maxHeight = body.scrollHeight + 'px';
      // A fixed max-height left behind would clip the text again when it reflows
      timer = window.setTimeout(function() {
        if (expanded) body.style.maxHeight = 'none';
      }, 450);
    }

    function close() {
      window.clearTimeout(timer);
      var height = measure();
      if (height === null) return;
      setState(false);
      // Start from a fixed height so the max-height transition has something to run from
      body.style.maxHeight = body.scrollHeight + 'px';
      void body.offsetHeight;
      body.style.maxHeight = height + 'px';
      root.classList.add('is-collapsed');
      // The page just got shorter: bring the text back into view if it scrolled away above
      timer = window.setTimeout(function() {
        if (root.getBoundingClientRect().top < 0) {
          root.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }, 450);
    }

    function refresh() {
      var height = measure();
      toggle.hidden = !collapsible;
      if (!collapsible) {
        root.classList.remove('is-collapsed');
        body.style.maxHeight = '';
        setState(false);
        return;
      }
      if (!expanded) {
        body.style.maxHeight = height + 'px';
        root.classList.add('is-collapsed');
      }
    }

    toggle.addEventListener('click', function() {
      if (expanded) close();
      else open();
    });
    // A link in the clipped part must not take keyboard focus out of sight
    body.addEventListener('focusin', function() {
      if (collapsible && !expanded) open();
    });

    return { refresh: refresh };
  }

  function init(scope) {
    scope.querySelectorAll('[data-seo-collapse]').forEach(function(root) {
      if (!root.seoCollapse) root.seoCollapse = setup(root);
      if (root.seoCollapse) root.seoCollapse.refresh();
    });
  }

  var resizeTimer;
  init(document);
  // Web fonts and images change the wrapping, hence the line the limit falls on
  window.addEventListener('load', function() {
    init(document);
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function() {
      init(document);
    });
  }
  window.addEventListener('resize', function() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function() {
      init(document);
    }, 150);
  });
  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();
